/**
 * Basic Configurator's policy for an unavailable `?lang=`: fall back to the
 * project default and tell the user. The platform only reports the fact
 * (ADR-0075 decision 3), so each application picks its own recovery.
 */
export interface LanguageIssue {
  requested: string;
  /**
   * False when translations were already loaded: the provider keeps the
   * working language, so there is nothing to fall back from.
   */
  fallbackApplied: boolean;
}

/** The language to request; `undefined` asks the platform for its default. */
export function effectiveRequestedLanguage(
  requestedLanguage: string | undefined,
  issue: LanguageIssue | null,
): string | undefined {
  // Compare against the failed language, so a later ?lang= still gets a try.
  if (issue?.fallbackApplied && issue.requested === requestedLanguage) return undefined;
  return requestedLanguage;
}
